import { convertQueryParamStringToMap } from '../route-provider'

export function parseRouteFromHash(hash: string): string[] {
  return hash.split('/').slice(1)
}

export function getRouteParams() {
  return parseRouteFromHash(location.hash)
}

type ParamsGetter = () => string[]

export function getApplicationDrilldownID(parameters: string[]) {
  return parameters[1] === 'applications' && parameters[2]
    ? parameters[2]
    : undefined
}
export function getApplicationOrgId(parameters: string[]) {
  return parameters[1] === 'applications' && parameters[0]
    ? parameters[0]
    : undefined
}

export function getServerDrilldownID(parameters: string[]) {
  return parameters[1] === 'servers' && parameters[2]
    ? parameters[2]
    : undefined
}

export function getVulnerabilityDrilldownID(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'vulns' && routeParams[2]
    ? routeParams[2]
    : undefined
}

export function getVulnerabilityDrilldownIDFromLocation() {
  return getVulnerabilityDrilldownID(getRouteParams)
}

export function getApplicationVulnerabilityDrilldownID(
  paramsGetter: ParamsGetter
) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'applications' &&
    routeParams[2] &&
    routeParams[3] === 'vulns' &&
    routeParams[4]
    ? routeParams[4].split('?')[0]
    : undefined
}

export function getApplicationVulnerabilityDrilldownIDFromLocation() {
  return getApplicationVulnerabilityDrilldownID(getRouteParams)
}

export function getServerVulnerabilityDrilldownID(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'servers' &&
    routeParams[2] &&
    routeParams[3] === 'vulns' &&
    routeParams[4]
    ? routeParams[4].split('?')[0]
    : undefined
}

export function getServerVulnerabilityDrilldownIDFromLocation() {
  return getServerVulnerabilityDrilldownID(getRouteParams)
}

export function getSourceNameID(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'rules' &&
    routeParams[2] === 'ip' &&
    routeParams[3] === 'source-names' &&
    routeParams[4] === 'edit'
    ? routeParams[5]
    : undefined
}

export function getSourceNameIDFromLocation() {
  return getSourceNameID(getRouteParams)
}

export function getSensitiveDataTypeID(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'rules' &&
    routeParams[2] === 'sensitive' &&
    routeParams[3] === 'edit'
    ? routeParams[4]
    : undefined
}

export function getSensitiveDataTypeIDFromLocation() {
  return getSensitiveDataTypeID(getRouteParams)
}

export function getVulnerabilityPolicyIDFromLocation() {
  return getVulnerabilityPolicyID(getRouteParams)
}

export function getVulnerabilityPolicyID(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'rules' &&
    routeParams[2] === 'vulnerability-management' &&
    routeParams[3] === 'policy' &&
    routeParams[4] === 'edit'
    ? routeParams[5]
    : undefined
}

export function getVulnerabilityPolicyActionFromLocation() {
  return getVulnerabilityPolicyAction(getRouteParams)
}

export function getVulnerabilityPolicyAction(paramsGetter: ParamsGetter) {
  const routeParams = paramsGetter()

  return routeParams[1] === 'rules' &&
    routeParams[2] === 'vulnerability-management' &&
    routeParams[3] === 'policy' &&
    routeParams[4] === 'add'
    ? routeParams[5]
    : undefined
}

export function getVulnerabilityPolicyActionOnCancel(
  paramsGetter: ParamsGetter
): Map<string, string> {
  const routeParams = paramsGetter()

  return routeParams[1] === 'rules' && routeParams[2]
    ? convertQueryParamStringToMap(routeParams[2].split('?')[1])
    : new Map<string, string>()
}

export function getVulnerabilityPolicyActionOnCancelFromLocation(): Map<
  string,
  string
> {
  return getVulnerabilityPolicyActionOnCancel(getRouteParams)
}
